module.exports = __webpack_public_path__ + "media/agent_2_furufuru.123eb05c.mp3";